import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-firma',
  templateUrl: './firma.component.html',
  styleUrls: ['./firma.component.css']
})
export class FirmaComponent implements OnInit {
  firma: FormGroup;
  constructor(public dialogRef: MatDialogRef<FirmaComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder) {
    this.dialogRef.disableClose = true;
    this.crearFormulario();
  }

  ngOnInit(): void {
  }


  crearFormulario(): any {
    this.firma = this.fb.group({
      tipo: [''],
    });
  }

  siguiente(event): any {
    console.log(event);
    this.dialogRef.close(event);
  }
}
